import { useState } from "react";
import { useTranslation } from "react-i18next";
import { panelThemeClasses } from "../../../theme/themeClasses";
import { Button, SectionHeader } from "../../../components/ui";
import { QuotesList } from "../../../components/quotes/QuotesList";
import { QuoteModal } from "../../../components/quotes/QuoteModal";
import { useDisableCRUD } from "../../../store/admin/companiesStore";
import { CRUDTooltip } from "../../../components/base/CRUDTooltip";

/** Lista de cotizaciones de transporte + alta desde cero (ruta guardada u origen/destino). */
export default function CotizacionesSection() {
  const { t } = useTranslation("finanzasOperativas");
  const themeClasses = panelThemeClasses();
  const disableCRUD = useDisableCRUD();
  const [creating, setCreating] = useState(false);

  return (
    <div className={`flex h-full w-full flex-col ${themeClasses.bg}`}>
      <SectionHeader
        title={t("sections.cotizaciones.title")}
        subtitle={t("sections.cotizaciones.subtitle")}
        actions={
          <CRUDTooltip>
            <Button size="sm" icon={<i className="ri-add-line" />} disabled={disableCRUD} onClick={() => setCreating(true)}>
              {t("sections.cotizaciones.new")}
            </Button>
          </CRUDTooltip>
        }
      />
      <div className="flex-1 overflow-y-auto p-3 sm:p-6">
        <QuotesList onCreate={disableCRUD ? undefined : () => setCreating(true)} />
      </div>
      {creating && <QuoteModal source={{ kind: "blank" }} onClose={() => setCreating(false)} />}
    </div>
  );
}
